import * as React from 'react';
import * as Modal from 'react-modal';
import Alert from '../../../../libs/controls/components/Alert';

// updated imports
import {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '../../../../entities/modal';
import { createCounterMessage } from '../../../../libs/helpers/Utils';

const MIN_LENGTH = 50;
const MAX_LENGTH = 1500;

interface State {
  open: boolean;
  comment: string;
  error: boolean;
  formType?: string;
  processId?: string;
}

interface Props {
  func: any;
  data: any;
}

export class ConfirmModal extends React.Component<Props, State> {
  state = {
    open: false,
    comment: '',
    error: false,
    formType: null,
    processId: null,
  };

  // TODO: используется за компонентом
  // eslint-disable-next-line react/no-unused-class-component-methods
  show = (formType = null, processId = null) => {
    this.setState({
      open: true,
      formType,
      processId,
    });
  };

  onChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { value } = event.target;
    this.setState({ comment: value });
  };

  onClose = () => {
    this.setState({
      open: false,
      comment: '',
    });
  };

  onOK = () => {
    const { comment, formType, processId } = this.state;
    const { func, data } = this.props;

    if (
      !comment ||
      comment.length < MIN_LENGTH ||
      comment.length > MAX_LENGTH
    ) {
      this.setState({ error: true });
    } else {
      this.setState({ open: false });
      if (formType && processId) {
        func(formType, processId, comment);
      } else {
        func(data.process_id, data.accept, comment);
      }
    }
  };

  render() {
    const { comment, open, error } = this.state;
    return (
      // @ts-ignore
      <Modal
        isOpen={open}
        ariaHideApp={false}
        style={{ overlay: { backgroundColor: 'rgba(0,0,0,.25)' } }}
        className="react-bs-insert-modal modal-dialog"
        contentLabel="Modal"
      >
        <div className="modal-content react-bs-table-insert-modal">
          <ModalHeader onClose={this.onClose}>Причина отказа</ModalHeader>
          <ModalBody>
            <textarea
              className="form-control"
              onChange={this.onChange}
              value={comment || ''}
            />
            <div className="input-counter">
              {createCounterMessage(comment, MAX_LENGTH, MIN_LENGTH)}
            </div>
            {error && (
              <Alert>Укажите причину отказа от 50 до 1500 символов</Alert>
            )}
          </ModalBody>
          <ModalFooter onSubmit={this.onOK} onClose={this.onClose} />
        </div>
      </Modal>
    );
  }
}
